<template>
  <el-dialog title="提示" :visible.sync="visible" width="1200px">
    <c-table
      class="mt-4"
      :isIndex="false"
      :isSelection="false"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      @loadPage="loadData"
    >
    </c-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="visible = false"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      visible: false,
      /* 数据源 */
      dataSource: [],
      /* 列 */
      columns: [
        { width: 160, label: "车牌号", prop: "license_plate" },
        { label: "地址", prop: "address" },
        {
          width: 160,
          label: "调用时间",
          prop: "request_time",
          formatData: row =>
            row.request_time ? moment.unix(row.request_time).format("YYYY-MM-DD HH:mm:ss") : "--"
        },
        {
          width: 160,
          label: "最后上报时间",
          prop: "report_time",
          formatData: row =>
            row.report_time ? moment.unix(row.report_time).format("YYYY-MM-DD HH:mm:ss") : "--"
        },
        {
          width: 160,
          label: "是否离线",
          prop: "is_offline",
          formatData: row => (row.is_offline == 0 ? "否" : "是")
        }
      ],
      /* 数据总数 */
      total: 0,
      /* 分页 */
      pagintion: {
        page: 1,
        page_size: 1
      },
      params: {}
    };
  },
  methods: {
    /* 打开弹窗 */
    onOpen(row) {
      this.dataSource = [];
      this.params = row;
      this.visible = true;
      this.loadData();
    },
    async loadData() {
      const res = await this.$common.http({
        url: "/api/queue/admin/car_track",
        data: Object.assign(this.pagintion, this.params)
      });
      const { total, data } = res.data.data;
      this.total = total;
      this.dataSource = data;
    }
  }
};
</script>

<style lang="scss" scoped></style>
